import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Dimmer } from "@/components/spinner";
import { useSound } from "react-sounds";
import customClickSound from "@/tonos/warning.mp3";
export default function BarraLateral(props) {
  const { play } = useSound(customClickSound);
  const op = require("@/modulos/datos");
  const wsRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(new Date());
  const [items, setItems] = useState([]);
  const ultimoLlamado = items.length > 0 ? items[0] : null;
  const ultimosAtendidos = items.length > 1 ? items.slice(1) : [];

  const buscarTickets = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${op.conexion}/api/atendidos/consultar_panel`,
      );
      if (response.status === 200 && response.data) {
        setItems(response.data);
      }
    } catch (error) {
      console.error("Error al buscar tickets:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarTickets();
    const timerId = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timerId);
  }, []);

  useEffect(() => {
    const ws = new WebSocket(`${op.ws}`);
    wsRef.current = ws;
    ws.onopen = () => {};
    ws.onmessage = (event) => {
      if (event.type === "message" && event.data) {
        const { type } = JSON.parse(event.data);
        if (type === "ticket_orden") {
          setTimeout(() => {
            play();

            buscarTickets();
          }, 500);
        }
      }
    };
    ws.close = () => {
      console.log("❌ Desconectado");
    };
    return () => {
      ws.close();
    };
  }, []);
  return (
    <div
      className="container p-0 m-0 text-black"
      style={{
        width: "100%",
        height: "96vh",
      }}
    >
      {/* Reloj */}
      <div
        className="card text-white border-0 shadow-lg overflow-hidden position-relative"
        style={{
          width: "100%",
          background: "linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)",
          borderRadius: "1rem",
          padding: 0,
          margin: 0,
        }}
      >
        {/* Efecto decorativo de brillo de fondo */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              "radial-gradient(circle at top right, rgba(255,255,255,0.2), transparent 60%)",
            pointerEvents: "none",
          }}
        ></div>

        <div className="card-body text-center d-flex flex-column justify-content-center align-items-center p-4">
          <span
            className="text-uppercase tracking-wider small opacity-75 mb-1 fw-semibold"
            style={{ letterSpacing: "2px" }}
          >
            Hora Actual
          </span>
          <span className="display-5 font-monospace fw-bold m-0 p-0 text-shadow" style={{
            fontSize:'2.5rem'
          }}>
            {time.toLocaleTimeString()}
          </span>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: "90%",
          overflow: "hidden",
          position: "relative",
          background: "#001133",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {items.length === 0 ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontSize: "1.5rem",
            }}
          >
            No hay fichas pendientes
          </div>
        ) : (
          <>
            {/* Bloque: Último llamado */}
            {ultimoLlamado && (
              <div
                style={{
                  height: "30%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "5px",
                  borderBottom: "3px solid #00ff00",
                  background: "rgba(0, 255, 0, 0.1)",
                  color: "white",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.7rem",
                    color: "#00ff00",
                    marginBottom: "10px",
                  }}
                >
                  🔔 ÚLTIMO LLAMADO
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "2rem",
                    marginBottom: "2px",
                  }}
                >
                  Ficha #{ultimoLlamado.numaten}
                </div>
                <div style={{ fontSize: "1.5rem", marginTop: "5px" }}>
                  Caja: {ultimoLlamado.numcaja}
                </div>
                <div style={{ fontSize: "1.2rem", marginTop: "5px" }}>
                  Contribuyente: {ultimoLlamado.nombre}
                </div>
              </div>
            )}

            {/* Bloque: Últimos atendidos */}
            {ultimosAtendidos.length > 0 && (
              <div
                style={{
                  height: "70%", // Ocupa el 65% del espacio
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    color: "#87CEEB",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    padding: "10px 0",
                    borderBottom: "2px solid #87CEEB",
                    marginBottom: "5px",
                  }}
                >
                  📋 ÚLTIMOS ATENDIDOS
                </div>
                <div
                  style={{
                    flex: 1,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {ultimosAtendidos.map((item) => (
                    <div
                      key={item.id}
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "5px",
                        borderBottom: "1px solid #444",
                        color: "white",
                        fontSize: "1rem",
                        minHeight: "80px",
                      }}
                    >
                      <div style={{ fontWeight: "bold", fontSize: "1.5rem" }}>
                        Ficha #{item.numaten}
                      </div>
                      <div style={{ fontSize: "1.2rem", marginTop: "3px" }}>
                        Caja: {item.numcaja}
                      </div>
                      <div style={{ fontSize: "1rem", marginTop: "3px" }}>
                        Contribuyente: {item.nombre}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <Dimmer setInterval active={loading} />
    </div>
  );
}
